import { useNotifications } from '../composables/useNotifications'

export default {
    install(app) {
        const notifications = useNotifications()

        // Make notifications available globally via $notify
        app.config.globalProperties.$notify = {
            success: notifications.success,
            error: notifications.error,
            warning: notifications.warning,
            info: notifications.info,

            // Generic method with full options
            show: notifications.addToast
        }

        // Provide notifications for composition API
        app.provide('notifications', notifications)
    }
}
